export default __webpack_public_path__ + "static/media/TXUI_Foundation_Corner_8x4.256.27ea3789.png";